import React from 'react';
import Tile from '../../../../app/common/components/Tile';
import Checkbox from '../../../../app/common/components/Checkbox';
import OverlayDialog from '../../../../app/common/components/OverlayDialog';
import Spinner from '../../../../app/common/components/Spinner';
import { TranslationHelpers } from '../../../../i18n/translationHelpers';
import ICONS from '../../../../app/common/constants/icons';
import Icon from '../../../../app/common/components/Icon';
import DeleteConfirmation from '../../DeleteConfirmation';
import {
    AgreementLink,
    Bottom,
    DeleteLink,
    DeleteLinkWrapper,
    ImgLogo,
    IntroText,
    Loading,
    mainTileStyles,
    OptionalCheckbox,
    ServiceInfo,
    ServiceLogo,
    Wrapper,
} from '../../sharedStyles';

export default class RakutenServices extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOverlayOpen: false,
            memberLoggedIn: props.memberLoggedIn,
            services: props.services,
        };

        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.onConfirmationClose = this.onConfirmationClose.bind(this);
        this.onAcceptDelete = this.onAcceptDelete.bind(this);
        this.onNewsletterUpdateRequest = this.onNewsletterUpdateRequest.bind(this);
        this.getAgreementsLinkByLanguage = this.getAgreementsLinkByLanguage.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.memberLoggedIn !== state.memberLoggedIn) {
            return null;
        }

        return {
            memberLoggedIn: props.memberLoggedIn,
            services: props.services,
        };
    }

    componentDidMount() {
        this.props.getAgreementsLinksAndNewsletterStatus();
        this.props.loadServicesConfig();
    }

    // Account Deletion Code - START
    onDeleteClick(event) {
        event.preventDefault();
        this.setState({
            isOverlayOpen: true,
        });
        this.props.startDeleteAccount();
    }

    onConfirmationClose() {
        this.setState({
            isOverlayOpen: false,
        });
    }

    onAcceptDelete(password) {
        this.props.deleteAccount(this.props.member, password);
    }

    // Account Deletion Code - END
    onNewsletterUpdateRequest(nl) {
        this.props.updateNewsletterStatus(nl);
    }

    onExternalLinkClick(event, data) {
        event.preventDefault();
        if (data.page && data.destination) {
            this.props.trackAgreementClick(data);
        } else {
            this.props.trackExternalLink(data);
        }
        window.open(event.currentTarget.getAttribute('href'), '_blank');
    }

    getServiceDetailsByConfig(service) {
        const { servicesConfig } = this.props;

        const defaultServiceDetails = servicesConfig['default'];
        const logo =
            (servicesConfig[service.serviceUuid] && servicesConfig[service.serviceUuid].logo) ||
            defaultServiceDetails.logo;
        const name =
            (servicesConfig[service.serviceUuid] && servicesConfig[service.serviceUuid].name) ||
            service.serviceName;
        const description =
            (servicesConfig[service.serviceUuid] &&
                servicesConfig[service.serviceUuid].labelKey.intro) ||
            defaultServiceDetails.labelKey.intro;
        const newsletter =
            (servicesConfig[service.serviceUuid] &&
                servicesConfig[service.serviceUuid].labelKey.newsletter) ||
            defaultServiceDetails.labelKey.newsletter;

        let enabled = defaultServiceDetails.enableNewsletterManagement;
        if (
            servicesConfig[service.serviceUuid] &&
            typeof servicesConfig[service.serviceUuid].enableNewsletterManagement !== 'undefined'
        ) {
            enabled = servicesConfig[service.serviceUuid].enableNewsletterManagement;
        }

        return { logo, name, description, newsletter, enabled };
    }

    getAgreementsLinkByLanguage(service) {
        const { localeSet } = this.props;
        const { agreementMap } = service;
        let tc = null;
        let pp = null;
        let cp = null;
        if (agreementMap) {
            const firstLang = Object.keys(agreementMap)[0];

            tc =
                (agreementMap[localeSet] && agreementMap[localeSet].tc) ||
                (agreementMap['en'] && agreementMap['en'].tc) ||
                (agreementMap[firstLang] && agreementMap[firstLang].tc);
            pp =
                (agreementMap[localeSet] && agreementMap[localeSet].pp) ||
                (agreementMap['en'] && agreementMap['en'].pp) ||
                (agreementMap[firstLang] && agreementMap[firstLang].pp);
            cp =
                (agreementMap[localeSet] && agreementMap[localeSet].cp) ||
                (agreementMap['en'] && agreementMap['en'].cp) ||
                (agreementMap[firstLang] && agreementMap[firstLang].cp);
        }
        return { tc, pp, cp };
    }

    render() {
        const {
            services,
            servicesConfig,
            gettingALinksAndNLStatus,
            errorDeletingAccount,
            loadingServicesConfig,
            loadingServicesConfigError,
        } = this.props;
        const someServiceUpdating = services.some((service) => service.updating);
        return (
            <Wrapper data-qa-id="rakuten-services-section">
                <OverlayDialog
                    title={TranslationHelpers.getMessageDescriptor(
                        'rakservice.delete_confirmation.title',
                    )}
                    isOpen={this.state.isOverlayOpen}
                    onClose={this.onConfirmationClose}
                >
                    <DeleteConfirmation
                        onAccept={this.onAcceptDelete}
                        onClose={this.onConfirmationClose}
                        apiError={errorDeletingAccount}
                        deleting={this.props.deleteConfirmationOpen}
                    />
                </OverlayDialog>
                {(gettingALinksAndNLStatus ||
                    loadingServicesConfig ||
                    someServiceUpdating ||
                    loadingServicesConfigError) && (
                    <Loading>
                        <Spinner size={50} />
                    </Loading>
                )}

                {services &&
                    servicesConfig &&
                    !loadingServicesConfigError &&
                    services.map((service, index) => {
                        const { tc, pp, cp } = this.getAgreementsLinkByLanguage(service);
                        const { logo, name, description, newsletter, enabled } =
                            this.getServiceDetailsByConfig(service);

                        return (
                            <Tile
                                localStyles={mainTileStyles}
                                key={`${service.serviceUuid}-${index}`}
                            >
                                <ServiceInfo>
                                    <ServiceLogo>
                                        <ImgLogo src={logo} alt={name} />
                                    </ServiceLogo>
                                    <IntroText className="tst-rsintro">
                                        {TranslationHelpers.getFormattedMessage(description, {
                                            serviceName: name,
                                        })}
                                    </IntroText>
                                    {tc && (
                                        <AgreementLink
                                            href={tc}
                                            onClick={(e) =>
                                                this.onExternalLinkClick(e, {
                                                    page: 'Rakuten Services',
                                                    destination: 'Terms and Conditions',
                                                })
                                            }
                                        >
                                            {TranslationHelpers.getFormattedMessage(
                                                'rakservice.check.tc',
                                            )}
                                        </AgreementLink>
                                    )}

                                    {pp && (
                                        <AgreementLink
                                            href={pp}
                                            onClick={(e) =>
                                                this.onExternalLinkClick(e, {
                                                    page: 'Rakuten Services',
                                                    destination: 'Privacy Policy',
                                                })
                                            }
                                        >
                                            {TranslationHelpers.getFormattedMessage(
                                                'rakservice.check.pp',
                                            )}
                                        </AgreementLink>
                                    )}
                                    {cp && (
                                        <AgreementLink
                                            href={cp}
                                            onClick={(e) =>
                                                this.onExternalLinkClick(e, {
                                                    page: 'Rakuten Services',
                                                    destination: 'Cookies consent',
                                                })
                                            }
                                        >
                                            {TranslationHelpers.getFormattedMessage(
                                                'rakservice.check.cp',
                                            )}
                                        </AgreementLink>
                                    )}

                                    {enabled && (
                                        <OptionalCheckbox className="tst-nslt">
                                            <Checkbox
                                                id={`newsletterStatus-${service.serviceUuid}`}
                                                name="newsletter"
                                                ariaLabel="Subscribed to the Newsletter"
                                                value={service.nlSubscription}
                                                onChange={() => {
                                                    this.onNewsletterUpdateRequest({
                                                        nlSubscription: !service.nlSubscription,
                                                        serviceUuid: service.serviceUuid,
                                                    });
                                                }}
                                            />
                                            <p>
                                                {TranslationHelpers.getFormattedMessage(newsletter)}
                                            </p>
                                        </OptionalCheckbox>
                                    )}
                                </ServiceInfo>
                            </Tile>
                        );
                    })}
                <Bottom>
                    <DeleteLinkWrapper>
                        <DeleteLink href="#" onClick={this.onDeleteClick}>
                            <Icon icon={ICONS.TRUSH} />
                            <span>
                                {TranslationHelpers.getFormattedMessage('button.delete_account')}
                            </span>
                        </DeleteLink>
                    </DeleteLinkWrapper>
                </Bottom>
            </Wrapper>
        );
    }
}
